import React from 'react';
import PropTypes from 'prop-types';

import { stagesDescription } from '../config';

export default function StageLabel({ stage }) {
  if (!stage) return null;

  return (
    <div className="stages-settings__stage">
      <div className="d-flex align-items-center mt-4 mb-2">
        <div className={`stages-settings__stage-color ${stage.key}`}></div>
        <h3 className="stages-settings__stage-label m-0">{stage.label}</h3>
      </div>
      <span className="stages-settings__stage-description">
        {stagesDescription[stage.key]}
      </span>
    </div>
  );
}

StageLabel.propTypes = {
  stage: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
};
